import { render, staticRenderFns } from "./LastMammoPart.vue?vue&type=template&id=dfe84f24&scoped=true&"
import script from "./LastMammoPart.ts?vue&type=script&lang=ts&"
export * from "./LastMammoPart.ts?vue&type=script&lang=ts&"
import style0 from "./LastMammoPart.scss?vue&type=style&index=0&id=dfe84f24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe84f24",
  null
  
)

export default component.exports